import CreateSectionContent from './CreateSectionContent';

export default CreateSectionContent;
